import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";

const Title = (props) => {

  return (
    <Typography
      style={props.print ? { color: "#29438d" } : { color: "#000000" }}
      className={props.className}
      component="h2"
      variant="h6"
      gutterBottom
    >
      {props.children}
    </Typography>
  );
};

Title.propTypes = {
  children: PropTypes.node,
};

export default Title;
